import styled from '@emotion/styled'
import * as React from 'react'

import { Strong, Text, VerifiedIcon } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'

import Bullet from '../../common/Bullet'
import QspPopover from '../../common/QspPopover'
import { i18nKeyPrefix } from '../../i18n'

const QspPopoverContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`
const PRE = `${i18nKeyPrefix}-BASICS-PROVIDER-VERIFIED`

export default function Verified() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Bullet icon={<VerifiedIcon />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <div>
        <Text muted>No &nbsp;</Text>
        <QspPopoverContainer>
          <QspPopover />
        </QspPopoverContainer>
      </div>
    </Bullet>
  )
}
